/*SYSTEM IMPORTS*/
import React, { PureComponent } from "react"
import c from "classnames"
// import Link from 'components/Link'
import Btn from "components/ui/Btn"
import Burger from "components/Burger"
import Img from "components/Img"
import "./style"
import "./media"
import Link from "../../Link"

import ActionWrapp from "components/ui/ActionWrapp"

/*IMAGES*/
// import BtnIcons from './images/btn-icons.svg'
import BtnIcons from "images/btn-icons.svg"

import { ConnectReduxWith } from "helpers/Redux/connectRedux"
import LayoutWindow from "mixins/LayoutWindow"

/* CORES */
import AppCore from "cores/AppCore"

/* CONSTANTS */
import * as AnalyticAction from "constants/AnalyticAction"
import { IsArray, IsIsset, IsObject } from "helpers/ValueTests"

@ConnectReduxWith("ui", "routing", "settings")
@LayoutWindow
class Header extends PureComponent {
    prodHost = `https://skin.expert`

    getActionLink = (action = "chat") => {
        const {
            user: { seo_alias },
            has_moderator = false,
            settings: { landing_id },
        } = this.props

        if (has_moderator) {
            action = "moderator"
        }

        return `/doctor/${seo_alias}?action=${action}&landing_id=${landing_id}&from=doctor_landing`
    }

    isDevEnv = () => {
        return (
            window.location.hostname.indexOf("dev") !== -1 ||
            window.location.hostname.indexOf("stage") !== -1
        )
    }

    redirectToAction = (actionUrl) => {
        if (!this.isDevEnv()) {
            window.open(`${this.prodHost}${actionUrl}`, "_blank")
        } else {
            window.open(actionUrl, "_blank")
        }
    }

    handleToChat = () => {
        AppCore.GoogleAnalytic.eventAnalytic(
            AnalyticAction.VRITE_TO_DOCTOR,
            AnalyticAction.HEADER_BUTTON
        )

        const actionUrl = this.getActionLink("chat")

        this.redirectToAction(actionUrl)
    }

    handleToVideoChat = () => {
        AppCore.GoogleAnalytic.eventAnalytic(
            AnalyticAction.VIDEOCALL_TO_DOCTOR,
            AnalyticAction.HEADER_BUTTON
        )

        const actionUrl = this.getActionLink("video_chat")

        this.redirectToAction(actionUrl)
    }

    handleToggleMobileMenu = () => {
        AppCore.Ui.toggleMobileMenu()
    }

    render() {
        const {
            allow_video_consultation = 0,
            allow_chat_consultation = 0,
            scrollTop = 0,
            className,
            value,
            menu: _menu,
            ui = false,
        } = this.props

        let menu = []

        if (IsArray(_menu)) {
            menu = _menu
        } else if (IsObject(value) && IsArray(value.menu)){
            menu = value.menu
        }

        const { open_mobile_menu = false } = ui

        const denied_consultation = !IsIsset(allow_chat_consultation) && !IsIsset(allow_video_consultation)

        return (
            <header
                key={"header"}
                className={c(
                    "header",
                    {
                        fixed: scrollTop > 10,
                        "show-mobile-menu": open_mobile_menu,
                    },
                    className
                )}
            >
                <div className="header__top-panel">
                    <div className="container header__container">
                        <Burger onClick={this.handleToggleMobileMenu} />

                        <div className="header__content">
                            <div className="header__menu">
                                <div className="header__list-menu">
                                    {menu.map((item) => (
                                        <HeaderMenuItem
                                            key={item.id}
                                            text={item.title}
                                            to={item.link}
                                        />
                                    ))}
                                </div>

                                {!denied_consultation &&
                                    <ActionWrapp>
                                        {allow_chat_consultation == 1 &&
                                            <Btn
                                                className="btn-chat"
                                                onClick={this.handleToChat}
                                                image={<Img src={BtnIcons} div />}
                                            >
                                                {AppCore.Interfaces.t(
                                                    "DoctorLanding.Ui.Header.Index.ButtonWriteInChat"
                                                )}
                                            </Btn>
                                        }

                                        {allow_video_consultation == 1 && (
                                            <Btn
                                                className="btn-video"
                                                onClick={this.handleToVideoChat}
                                                image={<Img src={BtnIcons} div />}
                                            >
                                                {AppCore.Interfaces.t(
                                                    "DoctorLanding.Ui.Header.Index.ButtonVideoCall"
                                                )}
                                            </Btn>
                                        )}
                                    </ActionWrapp>
                                }
                            </div>
                        </div>
                    </div>
                </div>

                {open_mobile_menu && (
                    <div className="header__mobile-menu">
                        <div className="mobile-menu_block">
                            {menu.map((item) => (
                                <HeaderMobileMenuItem
                                    key={item.id}
                                    text={item.title}
                                    to={item.link}
                                    onClick={this.handleToggleMobileMenu}
                                />
                            ))}
                        </div>
                    </div>
                )}
            </header>
        )
    }
}

const HeaderMenuItem = (props) => (
    <div
        className={c(
            "header__menu-item",
            { "header__menu-item_active": props.active },
            props.className
        )}
    >
        <Link className="header__menu-link" to={props.to}>
            {props.text}
        </Link>
    </div>
)

const HeaderMobileMenuItem = (props) => (
    <div
        className={c(
            "header__mobile-menu-item",
            { "header__mobile-menu-item_active": props.active },
            props.className
        )}
        onClick={props.onClick}
    >
        <Link to={props.to} className="header__mobile-menu-link">
            {props.text}
        </Link>
    </div>
)

export { HeaderMenuItem, HeaderMobileMenuItem }
export default Header
